import request from '@a/js/request'

// 新增订单
export function CreateOrder(params, lang) {
  return request({
    url: '/g/v1/pay_bhy/order' + `?lang=${lang ? lang : 'zh'}`,
    method: 'post',
    data: params,
  })
}

// 取消订单
export function CancelOrder(params, lang) {
  return request({
    url: '/g/v1/pay_bhy/order/cancel' + `?lang=${lang ? lang : 'zh'}`,
    method: 'put',
    data: params,
  })
}
// 查询订单信息
export function GetOrderInfo(query, lang) {
  return request({
    url: '/g/v1/pay_bhy/order/result' + `?lang=${lang ? lang : 'zh'}`,
    method: 'get',
    params: query,
  })
}
// 查询订单支付状态
export function GetOrderIsPaid(query, lang) {
  return request({
    url: '/g/v1/pay_bhy/order/unpaid' + `?lang=${lang ? lang : 'zh'}`,
    method: 'get',
    params: query,
  })
}
